import { PayloadAction } from '../../../../store.model';
import { sortMessages } from '../function/sort-messages.function';
import { ActionType } from '../teamschat-dialog.action';
import { TeamschatDialogState } from '../teamschat-dialog.state';

import { ReceiveMessages } from './receive-messages.action';

export function receiveMessagesReducer(
    state: TeamschatDialogState,
    action: PayloadAction<ActionType, ReceiveMessages>,
): TeamschatDialogState {
    const ids = state.messages.map((e) => e.msftChatMessageId);
    const messages = action.payload.messages.filter(
        (e) => !ids.includes(e.msftChatMessageId),
    );
    messages.forEach((e) => {
        e.startTime = e.startTime != null ? new Date(e.startTime) : null;
        e.endTime = e.endTime != null ? new Date(e.endTime) : null;
    });

    const nextMessages = [...state.messages];
    nextMessages.push(...messages);

    const nextConversation = sortMessages(
        nextMessages,
        state.chatMember?.msftUserId,
    );

    return {
        ...state,
        hasPendingData: false,
        messages: nextMessages,
        conversation: nextConversation,
    };
}
